import * as t from  './actionTypes';
import * as api from './api';

export function loadLotto() {

    return (dispatch) => {
        dispatch({ type: t.SET_BUSY });

        api.getLotto((success, lotto, error) => {
            if (success) {
                dispatch({ type: t.LOTTO_LOAD_SUCCESS, lotto: lotto });
                dispatch({ type: t.UNSET_BUSY });
            } else if (error) {
                dispatch({ type: t.UNSET_BUSY });
            }
        });
    }
}

export function setLotto(lotto, successCB, errorCB) {
    return (dispatch) => {
        dispatch({ type: t.SET_BUSY });
        api.setLotto(lotto, function(success, lotto, error) {
            if (success) {
                dispatch({ type: t.LOTTO_CHANGE_SUCCESS, lotto: lotto });
                dispatch({ type: t.UNSET_BUSY });
            } else if (error) {
                dispatch({ type: t.UNSET_BUSY });
            }
        });
    }
}

export function createNewLotto(data, successCB, errorCB) {
    return (dispatch) => {
        dispatch({ type: t.SET_BUSY });

        api.createNewLotto(data, function(success, data, error) {
            if (success) {
                dispatch({ type: t.LOTTO_CREATE_SUCCESS, lotto: data });
                dispatch({ type: t.UNSET_BUSY });
                successCB();
            } else if (error) {
                dispatch({ type: t.UNSET_BUSY });
                errorCB(error);
            }
        })
    }
}

export function editLotto(id, data, successCB, errorCB) {
    return (dispatch) => {
        dispatch({ type: t.SET_BUSY });

        api.editLotto(id, data, function(success, data, error) {
            if (success) {
                dispatch({ type: t.LOTTO_EDIT_SUCCESS, id: id, lotto: data });
                dispatch({ type: t.UNSET_BUSY });
                successCB();
            } else if (error) {
                dispatch({ type: t.UNSET_BUSY });
                errorCB(error);
            }
        })
    }
}

export function deleteLotto(id, successCB, errorCB) {
    return (dispatch) => {
        dispatch({ type: t.SET_BUSY });

        api.deleteLotto(id, function(success, error) {
            if (success) {
                dispatch({ type: t.LOTTO_DELETE_SUCCESS, id: id });
                dispatch({ type: t.UNSET_BUSY });
                successCB();
            } else if (error) {
                dispatch({ type: t.UNSET_BUSY });
                errorCB(error);
            }
        })
    }
}
